export const PDF_QUOTE = `If this quote is accepted and work performed hereunder by TAI,
TAI’s total liability in connection with the work is limited to
the amount paid to TAI for the work. IN NO EVENT WILL TAI BE
LIABLE FOR ANY INDIRECT OR CONSEQUENTIAL LOSS, DAMAGE,
COST OR EXPENSE OF ANY KIND WHATEVER AND HOWEVER CAUSED,
EVEN IF TAI HAS BEEN ADVISED OF THEIR POSSIBILITY.
No action arising out of TAI’s work, regardless of
the form of action, may be brought more than one year
after the cause of action accrued. Exclusive jurisdiction
and venue for any such action against TAI shall be
in the Courts of Cobb County, Georgia.`;
export const BID_QUOTE = `THIS BID INCLUDES A WRITTEN REPORT PLUS ALL
KNOWN EXPENSES AND IS VALID FOR A PERIOD OF THIRTY DAYS.`;
export const DOT_QUOTE = '......................................................................................';

export const getPageMargins = `
 @media print {
    @page {
      margin: 0px;
      size: A4;
    }
    @page recommendationPage {
      size: A4;
      margin-top: 20px; /* custom margins */
      margin-bottom: 20px;
      margin-left: 10px;
      margin-right: 10px;
    }

    .recommendation-section {
      page: recommendationPage;
    }
      
    .page-break {
      display: block;
      page-break-before: always;
    }
    .page-footer {
      bottom: 0;
      text-align: center;
      padding: 10px;
    }
    .noTableBreak {
      page-break-inside: avoid;
    }
    .largePage {
      page: large;
      display: block;
      page-break-after: avoid;
    }
    @page large {
      size: A3;
      margin: 5mm;
    }

    .morning-report-pdf {
      zoom: 1 !important;
      transform: none !important;
    }

    .morning-report-pdf .print-record {
      width: 100%;
      page-break-inside: avoid;
    }

    .morning-report-pdf * {
      max-width: 100% !important;
      box-sizing: border-box;
      word-break: break-word;
      overflow-wrap: anywhere;
    }

    .page-break {
      display: block;
      page-break-before: always;
    }
}
`;

export enum DocumentParts {
  Header_With_Logo = '1',
  Header_Without_Logo = '2',
  Table_of_Contents = '0',
  Job_Order = '3',
  Vessel_Information = '4',
  Defect_Graph = '5',
  Summary_of_Inspection = '6',
  Recommendations = '7',
  Data_Sheets = '8',
  Tube_Charts = '9',
  Photos = '10',
  Strip_Charts = '11',
  Phase_Charts = '12',
  Calibration_Procedure = '13',
  Explanation_Of_Abbreviations = '14',
  Inspection_Procedure = '15',
  Hazard_Analysis = '16',
  Expense_Report = '17',
}
